import moment from 'moment-jalaali';

export const convertToPersianDate = (date) => {
  return moment(date).format('jYYYY/jMM/jDD');
};
